import { LayoutsHome } from "../layouts";
import { CustomLayout } from "../components/layouts";

import { CashPage } from "../modules/modules.accounting/pages.accounting/CashPage";
import { BankPage } from "../modules/modules.accounting/pages.accounting/BankPage";
import { AccountPayPage } from "../modules/modules.accounting/pages.accounting/AccountPayPage";
import { AccountReceivePage } from "../modules/modules.accounting/pages.accounting/AccountReceivePage";
import { CollectionSheetPage } from "../modules/modules.accounting/pages.accounting/CollectionSheetPage";
import { DailyCollectionPage } from "../modules/modules.accounting/pages.accounting/DailyCollectionPage";

const routesACCOUNTING = [
  {
    path: "/accounting/cash_control",
    layout: CustomLayout,
    component: CashPage,
  },
  {
    path: "/accounting/banks",
    layout: CustomLayout,
    component: BankPage,
  },
  {
    path: "/accounting/accountPay",
    layout: CustomLayout,
    component: AccountPayPage,
  },
  {
    path: "/accounting/accountReceive",
    layout: CustomLayout,
    component: AccountReceivePage,
  },
  {
    path: "/accounting/CollectionSheetPage",
    layout: CustomLayout,
    component: CollectionSheetPage,
  },
  {
    path: "/accounting/daily_collection_page",
    layout: CustomLayout,
    component: DailyCollectionPage,
  },
];
export default routesACCOUNTING;
